import React from 'react';
import { Drawer, Box, Typography, Button } from '@mui/material';

export default function DataPrivacyFlyin({ open, onClose, onConsent }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      data-testid="flyin-data-privacy"
      PaperProps={{ sx: { bgcolor: 'background.paper', color: 'text.primary', backgroundImage: 'none' } }}
    >
      <Box sx={{ width: { xs: 360, sm: 420 }, p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6">Data Privacy Preferences</Typography>
        <Typography variant="body2" sx={{ maxHeight: 280, overflow: 'auto' }}>
          We respect your privacy. This panel explains how your data is used, stored, and shared.
          Configure your preferences and provide consent to continue. You can withdraw consent at any time in settings.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="contained" onClick={() => { onConsent?.(); onClose?.(); }}>I Consent</Button>
          <Button variant="text" onClick={onClose}>Close</Button>
        </Box>
      </Box>
    </Drawer>
  );
}
